import { memo, useRef } from 'react';
import useSearchParams from '@/components/search/hooks/useSearchParams';
import useDevice from '@/hooks/useDevice';
import Drawer from '@/components/UI/drawer/Drawer';
import useDrawer from '@/hooks/useDrawer';
import Box from '@/components/UI/box/Box';
import styles from './MidTermPriceRange.module.scss';
import Menu from '@/components/UI/menu/Menu';
import { useForm } from 'react-hook-form';
import PriceRangeContainer from './priceRangeContainer/PriceRangeContainer';
import { addCommas } from '@persian-tools/persian-tools';
import FilterChips from '../reusabe/filterChips/FilterChips';
import useMidTermFilters from '@/components/search/hooks/useMidTermFilters';
export interface PriceRangeData {
  price: [number, number];
}
const MidTermPriceRange = () => {
  const {
    setQuery,
    queries
  } = useSearchParams();
  const {
    updateQueryParams,
    clearFilters,
    useSyncFormWithQuery
  } = useMidTermFilters();
  const {
    handleSubmit,
    control,
    reset
  } = useForm<PriceRangeData>({
    defaultValues: {}
  });
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const open = isDrawerOpen('PRICE_RANGE');
  const {
    isMobile
  } = useDevice();
  useSyncFormWithQuery(queries, reset);
  const closeRef = useRef<any>(null);
  const selectedPriceFilter = queries.min_price || queries.max_price;
  const onSubmit = form => {
    updateQueryParams(form, setQuery);
  };
  const handleResetFilter = e => {
    e.stopPropagation();
    const clearedFilter = clearFilters(queries, ['max_price', 'min_price']);
    reset(clearedFilter);
    setQuery(clearedFilter);
  };
  const handleClick = () => {
    if (open) {
      drawerClose();
    } else {
      drawerOpen('PRICE_RANGE');
    }
  };
  const handleClose = () => {
    drawerClose();
  };
  const buttonText = !!selectedPriceFilter ? `${queries.min_price ? ' از ' + addCommas(Number(queries.min_price) * 1000) : ''} ${queries.max_price ? ' تا ' + addCommas(Number(queries.max_price) * 1000) : ''}` : `قیمت ${queries?.checkin && queries?.checkout ? 'کل' : ''}`;
  return <Box className={styles['filter-price-range-wrapper']} data-sentry-element="Box" data-sentry-component="MidTermPriceRange" data-sentry-source-file="MidTermPriceRange.tsx">
      <FilterChips type="secondary" checked={!!selectedPriceFilter} handleClick={handleClick} handleClean={handleResetFilter} label={buttonText} endIcon name="price_filter" id="price-range-chips" data-sentry-element="FilterChips" data-sentry-source-file="MidTermPriceRange.tsx" />

      {!isMobile ? <Menu ref={closeRef} id="price-range" open={open} handleClose={drawerClose} className={styles['filter-item-container']} menuButtonId="price-range-chips">
          <PriceRangeContainer handleClose={handleClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilter} />
        </Menu> : <Drawer open={isDrawerOpen('PRICE_RANGE')} onClose={handleClose}>
          <PriceRangeContainer handleClose={handleClose} control={control} handleSubmit={handleSubmit} onSubmit={onSubmit} handleResetFilter={handleResetFilter} />
        </Drawer>}
    </Box>;
};
export default memo(MidTermPriceRange);